/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Nps/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
let NpsReports = React.lazy(() => import('./NpsReports/index'))
let NpsSettings = React.lazy(() => import('./NpsSettings/index'))



/** @type {import('Simple/types.js').View} */
export default function Nps({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Nps"
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'NpsReports'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="Nps.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-l6C': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Nps.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-l6C': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-l6C': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="NPS"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="The NPS score is calculated by subtracting the percentage of Detractors from the percentage of Promoters."
/>
</div>
<div
  data-testid="Nps.Vertical:2"
  data-view-path={viewPath}
 style={{'--mt-4-l6C': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="Nps.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-2-l6C': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-l6C': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal}`}
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Reports"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'NpsReports'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'NpsReports'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Settings"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'NpsSettings'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'NpsSettings'))}
/>
</div>
<div
  data-testid="Nps.Vertical:3"
  data-view-path={viewPath}
 style={{'--pl-2-l6C': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-l6C': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-1-l6C': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical3}`}
>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={flowValue === 'NpsReports'}>
<NpsReports
{...childProps}
  viewPath={`${viewPath}/NpsReports`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NpsSettings'}>
<NpsSettings
{...childProps}
  viewPath={`${viewPath}/NpsSettings`}
/>
</fromFlow.When>
</React.Fragment>
)}
</SuspenseBoundary>
</div>
</div>
</div>
{children}
</React.Fragment>)
}